import { Avatar, Box, Button, Typography } from '@mui/material';

/**
 * ChatRequestItem component displays a chat request with sender information and action buttons.
 *
 * @param {Object} props - Component props.
 * @param {string|number} props.id - Unique identifier for the chat request.
 * @param {string} props.sender - Name of the sender.
 * @param {string} props.avatar - URL of the sender's avatar image.
 * @param {function} props.handleRequest - Callback function to handle accept or decline actions.
 *   Receives (id, action) where action is either "accept" or "decline".
 * @returns {JSX.Element} Rendered chat request item.
 */
function ChatRequestItem({ id, sender, avatar, handleRequest }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: ' #F9F9F9',
        padding: '12px',
        border: '1px solid #E9E9E9',
        borderRadius: '8px',
        margin: '8px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Avatar src={avatar} sx={{ marginRight: '10px' }} />
        <Typography variant="h6" sx={{ marginRight: '10px' }}>
          {sender}
        </Typography>
      </Box>
      <Box>
        <Button
          variant="text"
          color="success"
          onClick={() => handleRequest(id, 'accept')}
        >
          Accept
        </Button>
        <Button
          variant="text"
          color="error"
          onClick={() => handleRequest(id, 'decline')}
        >
          Decline
        </Button>
      </Box>
    </Box>
  );
}

export default ChatRequestItem;
